import { lazy } from 'react';
//-----------------------|| PROJECT-IMPORTS ||------------------------------------
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
//-----------------------|| USER-MANAGEMENT ||------------------------------------
import UsersList from 'views/user-management/Users/list';
import UserDetails from 'views/user-management/Users/details';
//-----------------------|| PROFILE ||--------------------------------------------
import UserProfile from 'views/authentication/profile/profile';
//-----------------------|| CUSTOMER-MANAGEMENT ||--------------------------------
import CustomersList from 'views/customer-management/Customers/list';
import CustomerDetails from 'views/customer-management/Customers/details';
//-----------------------|| FORM-MANAGEMENT ||------------------------------------
import FormCongiuration from 'views/form-management/form-configuration/formConfiguations';
import RegionList from 'views/form-management/region-configuration/list';
import StateList from 'views/form-management/state-configuration/list';
import StateDetailsTab from 'views/form-management/state-configuration/detailsTab';
// import StateDetails from 'views/form-management/state-configuration/details';
import DistrictList from 'views/form-management/district-configuration/list';
import AnticoccidalList from 'views/form-management/anticoccidal-configuration/list';
//-----------------------|| FARM-MANAGEMENT ||------------------------------------
import FarmRecordsList from 'views/farm-management/farm-records/list';
import FarmRecordDetails from 'views/farm-management/farm-records/details';
//-----------------------|| REPORT-MANAGEMENT ||----------------------------------
import ReportsList from 'views/report-management/reports/list';
import ReportGenerationList from 'views/report-management/report-generation/list';
//-----------------------|| LAB-MANAGEMENT ||-------------------------------------
import LabRecordsList from 'views/lab-management/lab-records/list';
import LabRecordDetails from 'views/lab-management/lab-records/details';
import LabReports from 'views/farm-management/farm-records/lapReports';
//-----------------------|| APP-MANAGEMENT ||-------------------------------------
import AppVersionList from 'views/app-management/app-version/list';
//-----------------------|| DASHBOARD||-------------------------------------------
const Dashboard = Loadable(lazy(() => import('views/dashboard')));

// ==============================|| MAIN ROUTING ||============================== //
const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        //-----------------------|| PROFILE ||--------------------------------------------
        {
            path: '/user/profile',
            element: <UserProfile />
        },
        //-----------------------|| DASHBOARD||-------------------------------------------
        {
            path: '/dashboard',
            element: <Dashboard />
        },
        //-----------------------|| USER-MANAGEMENT ||------------------------------------
        {
            path: '/users/list',
            element: <UsersList />
        },
        {
            path: '/users/details/:id',
            element: <UserDetails />
        },
        //-----------------------|| FORM-MANAGEMENT ||------------------------------------
        {
            path: '/form-configuration',
            element: <FormCongiuration />
        },
        {
            path: '/region-configuration',
            element: <RegionList />
        },
        {
            path: '/state-configuration',
            element: <StateList />
        },
        {
            path: '/state-configuration/details/:id',
            element: <StateDetailsTab />
        },
        // {
        //     path: '/state-configuration/details/:id',
        //     element: <StateDetails />
        // },
        {
            path: '/district-configuration',
            element: <DistrictList />
        },
        {
            path: '/anticoccidial-configuration',
            element: <AnticoccidalList />
        },
        //-----------------------|| FARM-MANAGEMENT ||------------------------------------
        {
            path: '/farm-records/list',
            element: <FarmRecordsList />
        },
        {
            path: '/farm-records/details/:id',
            element: <FarmRecordDetails />
        },
        {
            path: '/farm-records/lab-records/:farmIndex',
            element: <LabReports />
        },
        //-----------------------|| REPORT-MANAGEMENT ||----------------------------------
        {
            path: '/customers/list',
            element: <CustomersList />
        },
        {
            path: '/customers/details/:id',
            element: <CustomerDetails />
        },
        //-----------------------|| REPORT-MANAGEMENT ||----------------------------------
        {
            path: '/reports/list',
            element: <ReportsList />
        },
        {
            path: '/reports-generation/list',
            element: <ReportGenerationList />
        },
        //-----------------------|| LAB-MANAGEMENT ||-------------------------------------
        {
            path: '/lab-records/list',
            element: <LabRecordsList />
        },
        {
            path: '/lab-records/details/:id',
            element: <LabRecordDetails />
        },
        //-----------------------|| APP-MANAGEMENT ||-------------------------------------
        {
            path: '/app-versions/list',
            element: <AppVersionList />
        },
    ]
};

export default MainRoutes;
